import { render, staticRenderFns } from "./ReportOrderOfProductsBySalesman.vue?vue&type=template&id=32f51204&scoped=true"
import script from "./ReportOrderOfProductsBySalesman.vue?vue&type=script&lang=js"
export * from "./ReportOrderOfProductsBySalesman.vue?vue&type=script&lang=js"
import style0 from "./ReportOrderOfProductsBySalesman.vue?vue&type=style&index=0&id=32f51204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f51204",
  null
  
)

export default component.exports